import React, { useState, useCallback } from "react";
import { getVehicleGroupsList } from "../../services/vehicle";
import Constants from "../../services/Constants";
import OTAPagination from "../OTAPagination";
import { getVehicleGroupsDataColumns } from "./VehicleGroupsDataColumns";

const POLL_ACTIVE = 5000;
const POLL_IDLE = 50000;

const VehicleGroupsDataGrid = (props) => {
  const columns = getVehicleGroupsDataColumns();
  const [refetchInterval, setRefetchInterval] = useState(POLL_IDLE);

  const onSuccess = useCallback((response) => {
    const rows = response?.data?.res ?? [];
    const hasInProgress = rows.some((r) => r.status === "IN_PROGRESS");
    setRefetchInterval(hasInProgress ? POLL_ACTIVE : POLL_IDLE);
  }, []);

  return (
    <OTAPagination
      columns={columns}
      //endpoint={Constants.LIST_VEHICLE_GROUPS}
      endpointFn={getVehicleGroupsList}
      queryName={"vehicleGroupsList"}
      filterMode="server"
      sortByDefault={"createdAt"}
      getRowId={(row) => row.vehicleGroupId}
      refetchInterval={refetchInterval}
      onSuccess={onSuccess}
      {...props}
    />
  );
};

export default VehicleGroupsDataGrid;
